module.exports = __webpack_public_path__ + "img/i-close.3c711a97.svg";